/**
 * Заголовок, в котором SPA передаёт токен сессии, и разбор его значения.
 *
 * Почему не стандартный `Authorization: Bearer <token>`. Прямой вызов публичной
 * функции Yandex Cloud Functions (`https://functions.yandexcloud.net/<идентификатор>`)
 * разбирает этот заголовок как IAM-токен и на любой другой Bearer отвечает
 * `403 {"errorCode":403,"errorMessage":"Forbidden: Not authorized","errorType":"ClientError"}`
 * **до** кода функции (наблюдение 18.10.2026: вход проходил, а первый же защищённый
 * запрос — экран заявки — получал 403, и в журнале функций запроса не было вовсе).
 * Поэтому у сервиса собственный заголовок: он доезжает до функции как есть и работает
 * одинаково на dev-сервере, в контейнере и в облаке. Стандартный `Authorization`
 * поддержан как альтернатива (контейнер, локальные клиенты, тесты), но в облаке его
 * занимает платформа — SPA им не пользуется.
 */

/** Имя заголовка с токеном сессии: его ставит SPA и читает бэкенд. */
export const SESSION_HEADER = 'X-Eleonora-Session';

/**
 * Токен из значения заголовка сессии: принимается и `Bearer <токен>`, и просто
 * `<токен>` (так удобнее проверять сервис через curl). Пустое значение, «Bearer» без
 * токена и лишние слова — null: неполный заголовок не должен доходить до проверки подписи.
 */
export function parseSessionToken(value: string | null | undefined): string | null {
  const parts = (value ?? '').trim().split(/\s+/);
  if (parts[0]?.toLowerCase() === 'bearer') parts.shift();
  return parts.length === 1 && parts[0] !== '' ? parts[0] : null;
}
